var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.333 64h-384C8.533 64 0 72.533 0 85.333v21.333h426.667V85.333c0-12.8-8.534-21.333-21.334-21.333zM0 341.333C0 352 8.533 362.667 21.333 362.667h384c10.667 0 21.333-10.667 21.333-21.333v-192H0v191.999zm341.333-106.666c23.467 0 42.667 19.2 42.667 42.667S364.8 320 341.333 320s-42.667-19.2-42.667-42.667 19.201-42.666 42.667-42.666zm-128 42.666H256V320h-42.667v-42.667zm-170.666 0h128V320h-128v-42.667z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.a84576f4d573b0e53fd85db9402a5e78.svg";
export { ForwardRef as ReactComponent };